import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import RadioButton from "../../../../components/radioButton/RadioButton";
import { URL_TYPES } from "../../../../common/utils/url_types";
import { punyToUnicode } from "../../../../utils/punyToUnicode";

import "./UrlOption.scss";

const humanNames = {
  [URL_TYPES.FQDN]: "fully_qualified_domain_name",
  [URL_TYPES.CORE_DOMAIN]: "whole_website",
  [URL_TYPES.PUBLIC_SUFFIX]: "top_level_domain",
};

const UrlOption = ({ type, node, isChecked, onChange, id }) => (
  <RadioButton
    className="url-option"
    isChecked={isChecked}
    onChange={onChange}
    id={id}
    name={"radio-group"}
  >
    <div className="url-option__website-details">
      <label htmlFor={id} className="url-option__website-rule">
        <div className="url-option__title">
          <FormattedMessage id={humanNames[type]} />
        </div>
        <div className="url-option__website-link">
          <span className="url-option__website-link-content">
            {type === URL_TYPES.PUBLIC_SUFFIX && "."}
            {`${punyToUnicode(node)}`}
          </span>
        </div>
      </label>
    </div>
    <p className="text-small" id={`${id}_description`}>
      <FormattedMessage id={`${humanNames[type]}_description`} />
    </p>
  </RadioButton>
);

UrlOption.propTypes = {
  type: PropTypes.string.isRequired,
  node: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default UrlOption;
